module.exports = __webpack_public_path__ + "static/media/deposit-confirm.7cfd0ab0.png";